<template>
  <div class="cal">
    <div class="left-arrow" @click="prevMonth()"></div>
    <div>
        <div>
          <div class="notice-text">{{notice1}}</div>
          <div class="notice-text">{{notice2}}</div>
          <div class="notice-text">{{notice3}}</div>
        </div>
      <div class="date-picker" id="date-picker" >
        <div v-for="(month, idx) in months" :key="`m-${month.monthName}`" style="display:flex">
          <div>
            <div
              :class="['calendar', classChangeYear(idx, month.getMonth())]"
              :data-year="month.getYear()"
            >
              <div class="title">{{ month.monthName }}</div>
              <div
                v-for="(name, idx) in month.listDaysNames"
                :key="`dn-${idx}-${month.getMonth()}`"
                :class="`daysName col${ idx + 1 }`"
              >{{ name }}</div>

              <div
                v-for="(d, idx) in month.days"
                :key="`d-${idx}-${month.getMonth()}-${month.getYear()}`"
                :id="`d-${idx}-${month.getMonth()}-${month.getYear()}`"
                :class="['day', `week${ Math.floor(idx/7)+1 }`,`col${ (idx%7)+1 }`, classForDays(d, month.getMonth(), newRange)]"
                @mousedown="startSelection(d, $event)"
                @mouseover="moveSelection(d, $event)"
              >
                <p class="day-text">{{ d.getDate() }}</p>
              </div>
            </div>
          </div>
          <div
            v-if="classChangeYear(idx, month.getMonth()) == 'end-of-year'"
            class="separator"
            style="display: flex"
          >
            <div class="old-year">{{ month.getYear() }}</div>
            <div class="year-separator"></div>
            <div class="new-year">{{ month.getYear() + 1 }}</div>
          </div>
        </div>
      </div>
      <!--<div class="NoD" v-if="dates || newRange">
        <label for="numberofday">{{NoD_txt}}</label>
        <select name="numberofday" id="numberofday" v-model="selected" @change="onChangeNoD()">
          <option v-for="(nodv, idx) in NoD_value" :key="`${idx}-option`" :value="nodv">{{nodv}}</option>
        </select>
      </div>-->
      <div class="active-promo">
        <p>{{promoText}}</p>
      </div>
      <div class="date-picker-action">
        <button class="date-picker-btn date-picker-cancel" @click="cancel">{{cancelBtn}}</button>
        <button class="date-picker-btn date-picker-valid" @click="submit">{{validBtn}}</button>
      </div>
      <div>{{promo2D}}</div>
      <div class="legend" style="display:flex; flex-wrap:wrap; justify-content: center">
        <div
          class="bg-legend"
          v-for="(rp, idx) in getPromoLegend()"
          :key="`coul-${idx}`"
        >
          <!--<div v-if="rp.isContainedBy(months)" style="display:flex">-->
            <div :style="`background-color:${rp.color}; width:50px; height:25px; border-radius:10px; border: 1px solid ${rp.color}; margin: 5px; color:white`">-{{rp.percent}}%</div>
            <!--<div style="padding-top:10px;">-{{rp.percent}}% {{rp.getTextDates()}}</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="right-arrow" @click="nextMonth()"></div>
  </div>
</template>

<script>
import Month from "./Month";
import Ranges from "./Ranges";
import Range from "./Range";
let locale = window.navigator.language.toLowerCase().slice(0,2);
export default {
  name: "Calendar",
  components: {},
  props: {
    year: { type: Number, default: new Date().getFullYear() },
    parentStartMonth: { type: Number, default: new Date(new Date().getTime() + 259200000).getMonth() },
    monthNumber: { type: Number, default: 2 },
    value: Object
  },
  data() {
    return {
      startMonth: null,
      months: [],
      ranges: [],
      dates: null,
      newRange: null,
      cursor: 1,
      showModal: false,
      selectedRange: false,
      cancelBtn: '',
      validBtn: '',
      promoText: '',
      notice1: '',
      notice2: '',
      notice3: '',
      NoD_txt: '',
      NoD_value: [1,2,3,4,5,6,7,8,9,10],
      selected: 1,
      promo2D: '',
    };
  },
  methods: {
    onChangeNoD(){
      let date = this.dates.start
      let delta = (date.getTime() + ((this.selected - 1)* 24 * 60 * 60 * 1000))

      this.newRange = new Range(date, date);
      this.endSelection(new Date(delta))
    },
    getPromoLegend(){
      let rpl = []
      this.ranges.ranges.forEach(rp => {
        let finded = false
        rpl.forEach(rpl_item => {
          if(rpl_item.color == rp.color && rpl_item.percent == rp.percent){
            finded = true
          }
        })
        if(!finded){
          rpl.push({
          color: rp.color,
          percent: rp.percent
        })
        }
      });
      return rpl
    },
    classForDays(date, month, newRange) {
      let classes = [];
      if (date.getMonth() != month) {
        classes.push("light");
        return classes
      }

      let range = this.ranges.contains(date);

      if (
        range !== null &&
        (newRange == null || !newRange.contains(date))
      ) {

        let k = this.ranges.containsIndex(date);
        classes = []

        if (range.range.isStartRange(date)) {
          classes.push("range-promo-start");
        }

        if (range.range.isEndRange(date)) {
          classes.push("range-promo-end");
        }
        classes.push("range-promo");
        classes.push("promocolor-"+k);
      }

      if (newRange !== null && newRange.contains(date)) {

        classes = []

        if (newRange.isStartRange(date)) {
          classes.push("new-range-start");
        }

        if (newRange.isEndRange(date)) {
          classes.push("new-range-end");
        }
        classes.push("new-range");
      } /* else */

      if (this.dates && this.dates.contains(date)) {

        classes = []

        if (this.dates.isStartRange(date)) {
          classes.push("range-start");
        }

        if (this.dates.isEndRange(date)) {
          classes.push("range-end");
        }
        classes.push("range");
      } /* else */



      if (
        //date < new Date(new Date().getTime() + 172800000).setHours(0, 0, 0, 0)
        date < new Date(new Date().getTime() + 259200000).setHours(0, 0, 0, 0)
      ) {
        classes.push("passed");
      }
      //this.$forceUpdate()
      return classes;
    },
    stylePromo(date, id) {
      let el = document.getElementById(id);
      // eslint-disable-next-line
      //console.log(el)
      if (el != null && !el.classList.contains("range") && !el.classList.contains("new-range")) {
      //if (el != null && el.classList.contains("range-promo")) {
      //if (el != null) {
        let rangePromo = this.ranges.contains(date);
        // eslint-disable-next-line
      //console.log(rangePromo)
        if (rangePromo != null ){
          //el.style =  { backgroundColor: rangePromo.color }
          return { backgroundColor: rangePromo.color + ' !important'};
          }
        else return "";
      }
    },
    classChangeYear(index, month) {
      //this.$forceUpdate();
      if (index != this.months.length - 1 && month == 11) {
        return "end-of-year";
      } else if (index != 0 && month == 0) {
        return "start-of-year";
      } else {
        return "";
      }
    },
    startSelection(date, e) {
      e.preventDefault()
      e.stopPropagation()
      // eslint-disable-next-line
      //console.log(e.target)
      let el = e.target
      if (e.target.tagName == 'P') el = e.target.parentElement

      if(el.className.includes('light')) return

      if (
        //date >= new Date(new Date().getTime() + 172800000).setHours(0, 0, 0, 0)
        date >= new Date(new Date().getTime() + 259200000).setHours(0, 0, 0, 0)
      ) {
        //let range = this.dates;
        let range = this.newRange;
        if (range) {
          /*if (range.isStartRange(date)) {
            //this.newRange = range;
            //this.ranges.remove(range);
            this.cursor = -1;
          } else if (range.isEndRange(date)) {
            //this.newRange = range;
            //this.ranges.remove(range);
            this.cursor = 1;
          }*/
          this.endSelection(date)
        } else {
          this.dates = null
          this.newRange = new Range(date, date);
        }
        /* eslint-disable */
        /*let delta = (date.getTime() + ((this.selected - 1)* 24 * 60 * 60 * 1000))

          this.newRange = new Range(date, date);
          this.endSelection(new Date(delta))
          //this.endSelection(new Date(dtime + ((this.selected - 1)* 24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0))
          */
      }
      this.$forceUpdate();
    },
    moveSelection(date, e) {
      e.preventDefault()
      e.stopPropagation()
      // eslint-disable-next-line
      //console.log(e.target)
      let el = e.target
      if (e.target.tagName == 'P') el = e.target.parentElement

      if(el.className.includes('light')) return

      if (
        //date >= new Date(new Date().getTime() + 172800000).setHours(0, 0, 0, 0)
        date >= new Date(new Date().getTime() + 259200000).setHours(0, 0, 0, 0)
      ) {
        if (this.newRange) {
          if (this.cursor === 1 && date.getTime() - this.newRange.start.getTime() < 10 * 60 *60 *24 *1000) {
            if (date < this.newRange.start) {
              this.cursor = -1;
              return;
            }
            this.newRange.end = date;
          } else if(this.cursor === -1 &&  this.newRange.end.getTime() - date.getTime() < 10 * 60 *60 *24 *1000) {
            if (date > this.newRange.end) {
              this.cursor = 1;
              return;
            }
            this.newRange.start = date;
          }
        }
      }
      this.$forceUpdate();
    },
    endSelection(date=null) {
      if (this.newRange != null) {
        if(date != null && this.newRange.start == this.newRange.end){
          let time = date.getTime()
          if (date >= this.newRange.start && time - this.newRange.start.getTime() < 10 * 60 *60 *24 *1000){
            this.newRange.end = date
          } else if(date < this.newRange.start &&  this.newRange.start.getTime() - time < 10 * 60 *60 *24 *1000) {
            this.newRange = new Range(date, new Date(this.newRange.start));
            //this.newRange.end = new Date(this.newRange.start)
            //this.newRange.start = new Date(date)
          }
        }
        this.dates = this.newRange;
        this.newRange = null;
      }

      let fd = this.getFullDates()
      if (fd == null || fd.pourcentage == 0) {
        this.promoText = ''
        if (locale == 'fr'){
          this.promo2D = 'Promotion appliquée uniquement pour les réservations de 2 jours ou plus.'
        } else {
          this.promo2D = "'Promotion applied only for bookings of 2 days or more.'"
        }
      }
      else {
        this.promo2D = ''
        if (locale == 'fr'){
          this.promoText = "Avec ces dates, votre réduction sera de " + fd.pourcentage + "%."
        } else {
          this.promoText = "With these dates, your discount will be " + fd.pourcentage + "%."
        }
      }
      this.$forceUpdate();

    },
    startSelection2(e) {

      // eslint-disable-next-line
      //console.log(e)
      let x = e.touches[0].clientX
      let y = e.touches[0].clientY

      let mouseoverEvent = new Event('mousedown');

      // eslint-disable-next-line
      //console.log(document.elementFromPoint(x,y).parentElement)
      let allD = document.getElementsByClassName('day')
      allD = [...allD]
      let el = document.elementFromPoint(x,y).parentElement

      if(!allD.includes(el)) {
        el = this.findNearestEl(x,y)
      }
      el.dispatchEvent(mouseoverEvent)

    },
    moveSelection2(e) {

      // eslint-disable-next-line
      //console.log(e)
      let x = e.touches[0].clientX
      let y = e.touches[0].clientY

      let mouseoverEvent = new Event('mouseover');

      // eslint-disable-next-line
      //console.log(document.elementFromPoint(x,y).parentElement)
      let allD = document.getElementsByClassName('day')
      allD = [...allD]
      let el = document.elementFromPoint(x,y).parentElement

      if(!allD.includes(el)) {
        el = this.findNearestEl(x,y)
      }
      el.dispatchEvent(mouseoverEvent)

    },
    endSelection2() {
     /*  // eslint-disable-next-line
      console.log(e)
      let x = e.touches[0].clientX
      let y = e.touches[0].clientY

      let mouseoverEvent = new Event('mousedown');

      // eslint-disable-next-line
      //console.log(document.elementFromPoint(x,y).parentElement)
      let allD = document.getElementsByClassName('day')
      allD = [...allD]
      let el = document.elementFromPoint(x,y).parentElement

      if(!allD.includes(el)) {
        el = this.findNearestEl(x,y)
      }
      el.dispatchEvent(mouseoverEvent) */
      this.endSelection()
    },
    findNearestEl(x,y){
      let allD = document.getElementsByClassName('day')
      allD = [...allD]

      let nearest = null
      let mindist = 100000000

      for(let i=0;i<allD.length;i++){
        let el = allD[i]
        let elrect = el.getBoundingClientRect()
        let centerx = elrect.right - elrect.width/2
        let centery = elrect.top + elrect.height/2

        let dist = Math.sqrt(Math.pow(Math.abs(centerx - x),2) + Math.pow(Math.abs(centery - y),2))

        if (dist < mindist){
          mindist = dist
          nearest = el
        }
      }

      return nearest
    },
    deleteRange(date) {
      let range = [];

      while (range !== null) {
        range = this.dates !== null ? this.dates.contains(date) : null;
        if (range !== null) {
          this.dates = null;
        }
      }
      this.$forceUpdate();
    },
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      let toSubmit = {
        rangesPromo: this.ranges.toTimeStamps(true),
        dates: this.dates != null ? this.dates.toTimeStamps(true) : this.dates,
        fullDates: this.getFullDates()
      };
      this.$emit("input", toSubmit);
      this.$emit("submit");
    },
    getFullDates() {
      let timeStampsDate =
        this.dates != null ? this.dates.toTimeStamps(true) : this.dates;

      if (timeStampsDate !== null) {
        let nbJ = (timeStampsDate[1] - timeStampsDate[0]) / 86400 + 1;
        if (nbJ < 2 ){
          return {
            nbJ: nbJ,
            pourcentage: 0
          };
        }
        let pourcentage = nbJ >= 2 ? 10 : 0;

        /*for (let k in this.ranges.ranges) {
          if (

            this.ranges.ranges[k].range.isContainedBy(this.dates) ||
            this.ranges.ranges[k].range.intersect(this.dates)
          ) {
            if (pourcentage < this.ranges.ranges[k].percent)
              pourcentage = this.ranges.ranges[k].percent;
          }
        }*/
        let currRange = this.ranges.contains(this.dates.start);

        let rangePercent = 0;

        if (currRange) {
          rangePercent = currRange.percent
        }
        //let rangePercent = this.ranges.contains(this.dates.start).percent
        if (pourcentage < rangePercent) pourcentage = rangePercent
        return {
          nbJ: nbJ,
          pourcentage: pourcentage
        };
      } else {
        return null;
      }
    },
    prevMonth() {
      this.startMonth--;
      this.genMonthsToShow();
      setTimeout(this.$forceUpdate(), 500);
    },
    nextMonth() {
      this.startMonth++;
      this.genMonthsToShow();
      setTimeout(this.$forceUpdate(), 500);
    },
    genMonthsToShow() {
      if (this.months.length > 0) this.months = [];
      for (let i = 0; i < this.monthNumber; i++) {
        let newMonth = this.startMonth + i;
        let newYear = this.year;

        if (newMonth > 11) {
          newYear++;
          newMonth %= 12;
        }
        this.months.push(new Month(newYear, newMonth, locale));
        //this.$forceUpdate();
        //setTimeout(this.$forceUpdate(), 500);
      }
    },
    promocolor(){
      let pc = {}
      for(let i=0; i<this.ranges.length; i++){
        pc['--promocolor-'+i] = this.ranges[i].color
      }
      // eslint-disable-next-line
      //console.log(pc)
      return pc
    }
  },
  refresh(){
    this.$forceUpdate();
  },
  mounted() {
    this.cancelBtn = locale == 'fr' ? 'Annuler' : 'Cancel'
    this.validBtn = locale == 'fr' ? 'Valider' : 'Validate'
    this.$forceUpdate();

    let el = document.getElementById('date-picker')
    for(let i=0; i<this.ranges.ranges.length; i++){
      el.style.setProperty('--promocolor-'+i, this.ranges.ranges[i].color);
    }

    /* for(let i=0; i<this.ranges.ranges.length; i++){
      // eslint-disable-next-line
      //console.log(getComputedStyle(el).getPropertyValue('--promocolor-'+i))
    } */
  },
  created() {
    this.startMonth = new Number(this.parentStartMonth);
    this.ranges = Ranges.fromTimeStamps(this.value.rangesPromo, true);
    this.dates =
      this.value.dates === null
        ? null
        : Range.fromTimeStamps(this.value.dates, true);
    this.genMonthsToShow();

    if (locale == 'fr'){
      this.notice1 = "1) Clic sur date de début"
      //this.notice2 = "2) Selection nombre de jour(s)"
      this.notice2 = "2) Clic sur date de fin"
      this.notice3 = "3) Clic sur « valider » en dessous du calendrier"
      this.NoD_txt = 'Nombre de jour(s)'
      this.promo2D = 'Promotion appliquée uniquement pour les réservations de 2 jours ou plus.'
    } else {
      this.notice1 = "#1 Click on start date"
      //this.notice2 = "#2 Select number of day(s)"
      this.notice2 = "#2 Click on end date"
      this.notice3 = "#3 Click on « validate » below the calendar"
      this.NoD_txt = 'Number of Day(s)'
      this.promo2D = 'Promotion applied only for bookings of 2 days or more.'
    }

    /*
    let el = document.getElementById('date-picker')
    for(let i=0; i<this.ranges.length; i++){
      el.style.setProperty('--promocolor-'+i, this.ranges[i].color);
    }

    for(let i=0; i<this.ranges.length; i++){
      // eslint-disable-next-line
      console.log(getComputedStyle(el).getPropertyValue('--promocolor-'+i))
    } */
    //document.addEventListener("mouseup", this.endSelection);
  },
  updated() {
    //setTimeout(this.$forceUpdate(), 500);
    //this.$forceUpdate();
    /* let els = [...document.getElementsByClassName('day')]
    els.forEach(el => {
      let nd = new Date(el.dataset.date)
      // eslint-disable-next-line
      //console.log(el.dataset.date,nd, el.id)
      el.style = this.stylePromo(nd, el.id)
    }) */
  },
  computed: {

  },
  destroyed() {
    document.removeEventListener("mouseup", this.endSelection);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calendar {
  display: grid;
  padding: 0 20px;
  grid-template-columns: repeat(7, 1fr);
  /*grid-template-rows: repeat(8, 40px);*/
  grid-template-rows: repeat(8, 2.5em);
  /*width: 300px;*/
  width: 18.75em;
}
.calendar > .title {
  grid-column: 1 / 8;
  grid-row: 1 / 2;
  text-transform: uppercase;
  font-weight: bold;
  user-select: none;
}
.calendar > .daysName {
  grid-row: 2;
  text-transform: capitalize;
  font-weight: bold;
  user-select: none;
}
.calendar > * {
  line-height: 35px;
}
.calendar > .week1 {
  grid-row: 3;
}
.calendar > .week2 {
  grid-row: 4;
}
.calendar > .week3 {
  grid-row: 5;
}
.calendar > .week4 {
  grid-row: 6;
}
.calendar > .week5 {
  grid-row: 7;
}
.calendar > .week6 {
  grid-row: 8;
}
.col1 {
  grid-column: 1;
}
.col2 {
  grid-column: 2;
}
.col3 {
  grid-column: 3;
}
.col4 {
  grid-column: 4;
}
.col5 {
  grid-column: 5;
}
.col6 {
  grid-column: 6;
}
.col7 {
  grid-column: 7;
}
.light {
  opacity: 0 !important;
}
.date-picker {
  /*width: min(max-content, 90%);*/
  width :auto;
  margin: auto;
  display: flex;
  /*flex-wrap: wrap;*/
  justify-content: space-between;
}
.range {
  background-color: #0080b0;
  /* color: white; */
}
/*.range-start,
.new-range-start,*/
.range-promo-start {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
/*.range-end,
.new-range-end,*/
.range-promo-end {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.range-promo {
  background-color: rgba(80,255,80,0.3);
}
.new-range {
  background-color: #0080b0;
  /* color: white; */
}
.range-start,
.new-range-start,
.new-range-end,
.range-end {
  background-color: #0052b0;
}
.day {
  margin-bottom: 2px;
  user-select: none;
}
.date-picker-btn {
  border-width: 2px;
  border-style: solid;
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
  box-shadow: none;
  font-weight: bold;
  color: white;
}
.date-picker-cancel {
  /* color: white; */
  background-color: #fd3d3d;
  border-color: #fd3d3d;
}
.date-picker-valid {
  /* color: white; */
  background-color: #0f8332;
  border-color: #0f8332;
}
.left-arrow {
  margin: auto 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 20px 30px 0;
  border-color: transparent #0080b0 transparent transparent;
}
.right-arrow {
  margin: auto 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 0 30px 20px;
  border-color: transparent transparent transparent #0080b0;
}
.end-of-year {
  padding-right: 0px !important;
}
.start-of-year {
  padding-left: 0px !important;
}
@media screen and (max-width: 900px) {
  .separator{
    display:none !important;
  }
  .end-of-year {
  padding-right: 20px !important;
  }
  .start-of-year {
    padding-left: 20px !important;
  }
  .date-picker {
    flex-wrap: wrap;
  }
}
.year-separator {
  width: 2px;
  height: 300px;
  margin-top: 10px;
  background-color: #0080b0;
}
.old-year {
  height: 1.2rem;
  margin-top: auto;
  margin-bottom: 20px;
  color: #0080b0;
  font-weight: bold;
  transform: rotate(-90deg);
}
.new-year {
  height: 1.2rem;
  margin-top: 20px;
  margin-bottom: auto;
  color: #0080b0;
  font-weight: bold;
  transform: rotate(-90deg);
}
.btn-color {
  width: 50px;
  height: 50px;
  margin: auto;
  border: 1px lightgrey solid;
  border-radius: 15px;
}
.modal-colorpicker-content {
  padding: 10px 0;
}
label {
  line-height: 1.2rem;
}
p.day-text {
  margin: 0;
  /* mix-blend-mode: difference;
  color: whitesmoke; */
}
.passed {
  color: inherit;
  text-decoration: line-through;
  opacity: 0.5;
}
.cal {
  width:min-content;
  display: flex;
  justify-content: center;
}
.active-promo{
  color: rgb(240, 150, 14);
  font-weight: 700;
  font-size: 1.2em;
}
.promocolor-0{
  background: var(--promocolor-0);
}
.promocolor-1{
  background: var(--promocolor-1);
}
.promocolor-2{
  background: var(--promocolor-2);
}
.promocolor-3{
  background: var(--promocolor-3);
}
.promocolor-4{
  background: var(--promocolor-4);
}
.promocolor-5{
  background: var(--promocolor-5);
}
.promocolor-6{
  background: var(--promocolor-6);
}
.promocolor-7{
  background: var(--promocolor-7);
}
.promocolor-8{
  background: var(--promocolor-8);
}
.promocolor-9{
  background: var(--promocolor-9);
}
.promocolor-10{
  background: var(--promocolor-10);
}
.promocolor-11{
  background: var(--promocolor-11);
}
.promocolor-12{
  background: var(--promocolor-12);
}
.promocolor-13{
  background: var(--promocolor-13);
}
.promocolor-14{
  background: var(--promocolor-14);
}
.promocolor-15{
  background: var(--promocolor-15);
}
.promocolor-16{
  background: var(--promocolor-16);
}
.promocolor-17{
  background: var(--promocolor-17);
}
.promocolor-18{
  background: var(--promocolor-18);
}
.promocolor-19{
  background: var(--promocolor-19);
}
.promocolor-20{
  background: var(--promocolor-20);
}
.promocolor-21{
  background: var(--promocolor-21);
}
.promocolor-22{
  background: var(--promocolor-22);
}
.promocolor-23{
  background: var(--promocolor-23);
}
.promocolor-24{
  background: var(--promocolor-24);
}
.promocolor-25{
  background: var(--promocolor-25);
}
.promocolor-26{
  background: var(--promocolor-26);
}
.promocolor-27{
  background: var(--promocolor-27);
}
.promocolor-28{
  background: var(--promocolor-28);
}
.promocolor-29{
  background: var(--promocolor-29);
}
.promocolor-30{
  background: var(--promocolor-30);
}
.promocolor-31{
  background: var(--promocolor-31);
}
.promocolor-32{
  background: var(--promocolor-32);
}
.promocolor-33{
  background: var(--promocolor-33);
}
.promocolor-34{
  background: var(--promocolor-34);
}
.promocolor-35{
  background: var(--promocolor-35);
}
.promocolor-36{
  background: var(--promocolor-36);
}
.promocolor-37{
  background: var(--promocolor-37);
}
.promocolor-38{
  background: var(--promocolor-38);
}
.promocolor-39{
  background: var(--promocolor-39);
}
.promocolor-40{
  background: var(--promocolor-40);
}
.promocolor-41{
  background: var(--promocolor-41);
}
.promocolor-42{
  background: var(--promocolor-42);
}
.promocolor-43{
  background: var(--promocolor-43);
}
.promocolor-44{
  background: var(--promocolor-44);
}
.promocolor-45{
  background: var(--promocolor-45);
}
.promocolor-46{
  background: var(--promocolor-46);
}
.promocolor-47{
  background: var(--promocolor-47);
}
.promocolor-48{
  background: var(--promocolor-48);
}
.promocolor-49{
  background: var(--promocolor-49);
}
</style>
